var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3599 2.51241C12.9862 2.1825 12.5016 2 11.9993 2C11.497 2 11.0124 2.1825 10.6388 2.51241L3.1745 9.10341C2.96227 9.29095 2.79255 9.52026 2.67635 9.77645C2.56015 10.0326 2.50007 10.31 2.5 10.5904V19.9995C2.5 20.5301 2.71448 21.0389 3.09625 21.4141C3.47802 21.7892 3.99581 22 4.53571 22H7.25C7.78991 22 8.3077 21.7892 8.68947 21.4141C9.07124 21.0389 9.28571 20.5301 9.28571 19.9995V14.6648C9.28571 14.488 9.35721 14.3183 9.48446 14.1933C9.61172 14.0682 9.78432 13.998 9.96429 13.998H14.0357C14.2157 13.998 14.3883 14.0682 14.5155 14.1933C14.6428 14.3183 14.7143 14.488 14.7143 14.6648V19.9995C14.7143 20.5301 14.9288 21.0389 15.3105 21.4141C15.6923 21.7892 16.2101 22 16.75 22H19.4643C20.0042 22 20.522 21.7892 20.9038 21.4141C21.2855 21.0389 21.5 20.5301 21.5 19.9995V10.5904C21.4999 10.31 21.4398 10.0326 21.3236 9.77645C21.2074 9.52026 21.0377 9.29095 20.8255 9.10341L13.3612 2.51241H13.3599Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSolid);
export default __webpack_public_path__ + "static/media/home-solid.b94972309bf7ac6f6e62b467617aeb44.svg";
export { ForwardRef as ReactComponent };